import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import HeaderLayout from 'src/components/layouts/HeaderLayout';
import { IStateCollection } from 'src/entity/StateEntity';

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch: Dispatch<IStateCollection>) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderLayout);



// WEBPACK FOOTER //
// ./src/containers/HeaderLayout.ts